import type { DemandProcurementMasterRow } from '~/pages/AdminOcctoMaster/tabs/DemandProcurementPlanMaster/types'
import type { CsvColumnDef } from '~/pages/AdminOcctoMaster/tabs/_common/models/csvExport'

/**
 * 需要調達計画マスタタブの CSV エクスポート カラム定義
 * (spec AC-012b / design doc §5「タブ別 CSV カラム」)。
 * List レスポンスのフィールドのみを対象とし (AC-04)、詳細モーダルでのみ
 * 見える取引相手コード / 所属 BG の各リスト明細は含まない (件数のみを出力する)。
 */
export function demandProcurementPlanMasterCsvColumns(): Array<
  CsvColumnDef<DemandProcurementMasterRow>
> {
  return [
    {
      headerKey:
        'page:adminOcctoMaster.demandProcurementPlanMaster.column.bgCode',
      accessor: (row) => row.bgCode,
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandProcurementPlanMaster.column.note',
      accessor: (row) => row.note ?? '',
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandProcurementPlanMaster.column.codeCount',
      accessor: (row) => String(row.codeCount),
    },
    {
      headerKey:
        'page:adminOcctoMaster.demandProcurementPlanMaster.column.bgCount',
      accessor: (row) => String(row.bgCount),
    },
  ]
}
